<template>
  <div class="board">
    <div class="row" v-for="(row, y) in board" v-bind:key="y">
      <Cell
        v-for="(cell, x) in row"
        v-bind:key="x"
        v-bind:x="x"
        v-bind:y="y"
        v-bind:on="cell"
        v-bind:hint="hint && hint.x === x && hint.y === y"
        v-bind:onClick="switchCell"
      />
    </div>
  </div>
</template>

<script>
import Cell from "./Cell";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Cell
  },
  computed: {
    ...mapGetters(["board", 'hint'])
  },
  methods: {
    ...mapActions(["switchCell"])
  }
};
</script>

<style scoped>
.board {
  width: 300px;
}
.row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
